export default {
  UNDO: '@WS/HISTORY/UNDO',
  REDO: '@WS/HISTORY/REDO',
  SAVE_MUTATION: '@WS/HISTORY/SAVE_MUTATION',
  SET_HISTORY: '@WS/HISTORY/SET_HISTORY',
  CLEAR_HISTORY: '@WS/HISTORY/CLEAR_HISTORY',
  MERGE_HISTORY: '@WS/HISTORY/MERGE_HISTORY',
};
